import { types } from "../types/types";

const initialState = {
  cargada: false,
  itemsOrigen: [],
  itemsDestino: [],
  itemsDocOrigen: [],
  itemsDocDestino: [],
  loading: false,
  error: null,
};

export const grupoFamiliarCambioTitularidadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.grupoFamiliarCambioTitularidadTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.grupoFamiliarCambioTitularidadTraerOrigenSuccess:
      return {
        ...state,
        loading: false,
        itemsOrigen: action.payload,
        cargada: true,
      };
    case types.grupoFamiliarCambioTitularidadTraerDocOrigenSuccess:
      return {
        ...state,
        loading: false,
        itemsDocOrigen: action.payload,
        cargada: true,
      };
    case types.grupoFamiliarCambioTitularidadEvaluarDocOrigenSuccess:
      return {
        ...state,
        loading: false,
        itemsOrigen: state.itemsOrigen.map( item => item.id_afiliado === action.payload.idAfiliado
          ? {...item, documentacionCompleta: action.payload.estado} 
          : item
        ),
        cargada: true,
      };
    case types.grupoFamiliarCambioTitularidadTraerDestinoSuccess:
      return {
        ...state,
        loading: false,
        itemsDestino: action.payload,
        cargada: true,
      };  
    case types.grupoFamiliarCambioTitularidadTraerDocDestinoSuccess:
      return {
        ...state,
        loading: false,
        itemsDocDestino: action.payload,
        cargada: true,
      };  
    case types.grupoFamiliarCambioTitularidadEvaluarDocDestinoSuccess:
      return {
        ...state,
        loading: false,
        itemsDestino: state.itemsDestino.map( item => item.id_afiliado === action.payload.idAfiliado
          ? {...item, documentacionCompleta: action.payload.estado} 
          : item
        ),
        cargada: true,
      };
    case types.grupoFamiliarCambioTitularidadTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        itemsOrigen: [],
        itemsDestino: [],
        itemsDocOrigen: [],
        itemsDocDestino: [],
        cargada: false,
      };
    case types.grupoFamiliarCambioTitularidadOrigenLimpiar:
      return {
        ...state,
        loading: false,
        itemsOrigen: [],
        itemsDocOrigen: [],
        cargada: false,
      };
    case types.grupoFamiliarCambioTitularidadDestinoLimpiar:
      return {
        ...state,
        loading: false,
        itemsDestino: [],
        itemsDocDestino: [],
        cargada: false,
      };
    default:
      return state;
  }
};
